export default __webpack_public_path__ + "static/media/explore-tablet-1.e4610c0d.png";